<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<m-search-item label="费用分类">
                    <c-select name="fee_category" :options="feeCategoryDic" clearable></c-select>
				</m-search-item>
				<m-search-item label="费用类型">
					<c-select name="fee_type" :options="feeTypeDic" clearable></c-select>
				</m-search-item>
			</m-search>

<!--            <m-operate>-->
<!--                <c-button color="main" v-if="auth('b_fee_config_edit')" prepend-icon="tf-config" @click="openDistanceConfig">路程天数配置</c-button>-->
<!--            </m-operate>-->

			<c-table ref="list" height="grow" :paging="true">
				<c-table-column
					label="费用分类"
					name="fee_category"
					width="120"
				>
                    <template #default="{data}">
                        <c-state  dict="feeCategoryDic" tag :value="data.fee_category"></c-state>
                    </template>
                </c-table-column>

				<c-table-column
					label="费用类型"
					name="fee_type"
					width="120"
				>
                    <template #default="{data}">
                        <c-state  dict="feeTypeDic" tag :value="data.fee_type"></c-state>
                    </template>
                </c-table-column>

				<c-table-column
					label="单价"
					name="unit_price"
					width="130"
				>
                    <template #default="{data}">
                        {{data.unit_price.toFixed(2)}} {{data.calc_unit||''}}
                    </template>
                </c-table-column>

				<c-table-column
					label="其他规则"
					name="ladder_rules"
					width="400"
				>
					<template #default="{data}">
                        <span v-if="data.fee_type==4">
                            法定节日工资倍数：{{data.ladder_rules.festival_multiplier}}倍, 休息日工资倍数：{{data.ladder_rules.holiday_multiplier}}倍
                        </span>
                        <span v-if="data.fee_type==7">
                            {{data.ladder_rules.max_days}}天以内机台费用：{{data.ladder_rules.fee}}元，超出天数按单价计算（{{data.unit_price.toFixed(2)}} {{data.calc_unit||''}}）
                        </span>
					</template>
				</c-table-column>

				<c-table-column
					label="创建人"
					name="create_user_realname"
					width="110"
				></c-table-column>

				<c-table-column
					label="创建时间"
					name="create_date"
					width="120"
				></c-table-column>

                <c-table-column
                        label="更新人"
                        name="update_user_realname"
                        width="110"
                ></c-table-column>

                <c-table-column
                        label="更新时间"
                        name="update_date"
                        width="120"
                ></c-table-column>

				<c-table-column
                    v-if="auth('b_fee_config_edit')"
					type="button"
					label="操作"
					width="120"
					button-limit="3"
				>
					<template #default="{data}">
						<c-table-button v-if="auth('b_fee_config_edit')" icon="tf-edit" @click="editRule(data)">编辑</c-table-button>
					</template>
				</c-table-column>
			</c-table>

            <c-dialog ref="distanceConfigDialog" title="路程天数配置" width="600" @resolve="saveDistanceConfig">
                <c-tips>配置不同距离范围对应的额外天数，系统将自动根据路程距离计算所需天数</c-tips>
                <c-form ref="distanceForm">
                    <c-table ref="distanceTable" :paging="false" :data="distanceConfigList" auto-height="true" border>
                        <c-table-column
                                label="序号"
                                name="index"
                                width="40"
                                align-center
                        >
                            <template #default="{data}">
                                {{data.index}}
                            </template>
                        </c-table-column>

                        <c-table-column
                                label="最小距离(km)"
                                name="min_distance"
                                width="100"
                        >
                            <template #default="{data, index}">
                                <c-input v-model="distanceConfigList[index].min_distance" type="number" :precision="0" :clear="false"></c-input>
                            </template>
                        </c-table-column>

                        <c-table-column
                                label="最大距离(km)"
                                name="max_distance"
                                width="100"
                        >
                            <template #default="{data, index}">
                                <c-input v-model="distanceConfigList[index].max_distance" type="number" :precision="0" :clear="false"></c-input>
                            </template>
                        </c-table-column>

                        <c-table-column
                                label="额外天数"
                                name="extra_days"
                                width="100"
                        >
                            <template #default="{data, index}">
                                <c-input v-model="distanceConfigList[index].extra_days" type="number" :precision="0" :clear="false"></c-input>
                            </template>
                        </c-table-column>
                    </c-table>
                </c-form>
            </c-dialog>
            <fee-config-edit ref="edit" @resolve="$refs.list.update()"></fee-config-edit>
		</module>
	</page>
</template>

<script>
    import { mapState } from 'vuex';
    import feeConfigEdit from '@/pages/basic/fee_config_edit.vue';

	export default {
		components: {
            feeConfigEdit
		},

		data() {
			return {
                distanceConfigList: []
			}
		},

        computed:{
            ...mapState(['feeCategoryDic','feeTypeDic'])
		},

		mounted() {
			this.searchHandle();
		},

		methods: {
			searchHandle(data){
				if (!data){
					data = {};
				}
				this.$refs.list.load({
					url: '/aftersale/fee_config/list',
					data,
					success: () => {
					}
				});
			},

            editRule( data){
                this.$refs.edit.open(data);
            },

            openDistanceConfig(){
                this.request({
                    url: '/sys_saas/get/sys/config',
                    success: data => {
                        data.forEach(item => {
                            if(item.config_item_code == 'fee_config_extra_days' && item.config_item_value){
                                this.distanceConfigList = JSON.parse(item.config_item_value);
                                console.log(this.distanceConfigList);
                            }else{
                                this.distanceConfigList = [
                                    {index: 1, extra_days: 0, max_distance: 300, min_distance: 0},
                                    {index: 2, extra_days: 2, max_distance: 900, min_distance: 300},
                                    {index: 3, extra_days: 3, max_distance: 99999, min_distance: 900}
                                ];
                            }
                        });
                        this.$refs.distanceConfigDialog.open();
                    }
                });
            },
            saveDistanceConfig(stop, next){
                stop();
                const configData = this.distanceConfigList.map((item, idx) => ({
                    index: idx + 1,
                    extra_days: parseInt(item.extra_days) || 0,
                    max_distance: parseInt(item.max_distance) || 0,
                    min_distance: parseInt(item.min_distance) || 0
                }));
                var system_config_list = [];
                var obj0 = {
                    config_item_name:'路程天数配置',
                    config_item_code:'fee_config_extra_days',
                    config_item_type:4,
                    config_item_value:JSON.stringify(configData),
                    config_item_remark: '根据距离配置路程天数'
                }
                system_config_list.push(obj0);
                this.request({
                    url: '/sys_saas/set/sys/config',
                    method: 'POST',
                    data: {
                        system_config_list:system_config_list
                    },
                    success: () => {
                        next();
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                    }
                });
            }
		}
	}
</script>

<style lang="stylus" scoped>
</style>
